import "./App.css";
import HomePage from "./client/Pages/HomePage/HomePage";
import NavBar from "./client/components/Navbar";
import { Provider } from "./store/Provider";
import "./client/styles/pageTemplate.css";
import Footer from "./client/components/Footer";
import FleetPage from "./client/Pages/FleetPage/FleetPage";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Admin from "./admin/components/AdminApp";
import AboutPage from "./client/Pages/AboutPage/AboutPage";
import ReservationPage from "./client/Pages/ReservationPage/ReservationPage";
function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element:<div className="page"><NavBar /><HomePage /><Footer /></div>,
    },
    {
      path: "/fleet",
      element: <div className="page"><NavBar /><FleetPage /><Footer /></div>,
    },
    {
      path: "/about",
      element: <div className="page"><NavBar /><AboutPage /><Footer /></div>,
    },
    {
      path: "/admin",
      element: <Admin />,
    },
    {
      path: "/reservation",
      element: <div className="page"><NavBar /><ReservationPage/><Footer /></div>,
    },
  ]);

  const isAdmin = window.location.href.includes("admin");
  return (
    <Provider>
        <RouterProvider router={router} />
    </Provider>
  );
}

export default App;
